export const buildAppEmbedDeepLink = (myshopifyDomain, uuid, handle, template = null, themeId = null) => {
  const themePath = themeId ? `themes/${themeId}` : "themes/current";
  if (template)
    return `https://${myshopifyDomain}/admin/${themePath}/editor?context=apps&template=${template}&activateAppId=${uuid}/${handle}`
  return `https://${myshopifyDomain}/admin/${themePath}/editor?context=apps&activateAppId=${uuid}/${handle}`
};

export const buildAppBlockDeepLink = (myshopifyDomain, uuid, handle, target = "mainSection", template = "product", themeId = null) => {
  const themePath = themeId ? `themes/${themeId}` : "themes/current";
  return `https://${myshopifyDomain}/admin/${themePath}/editor?template=${template}&addAppBlockId=${uuid}/${handle}&target=${target}`
};

export const buildAppEmbedExpandDeepLink = (myshopifyDomain, uuid, handle) => {
  return `https://${myshopifyDomain}/admin/themes/current/editor?context=apps&appEmbed=${uuid}/${handle}`
};

/**
 * Build a URL to a specific page within the app in Shopify Admin
 * @param {string} myshopifyDomain - The store's myshopify domain (e.g., "my-store.myshopify.com")
 * @param {string} appName - The app's handle/name (e.g., "discount-planner-by-productessentials")
 * @param {string} path - The path within the app (e.g., "settings", "status")
 * @returns {string} The full Shopify Admin URL to the app page
 */
export const buildAppPageUrl = (myshopifyDomain, appName, path = "") => {
  // Extract store name from myshopify domain (e.g., "my-store" from "my-store.myshopify.com")
  const storeName = myshopifyDomain ? myshopifyDomain.split('.')[0] : '';
  if (!storeName) return `/${path}`;
  return `https://admin.shopify.com/store/${storeName}/apps/${appName}${path ? `/${path}` : ''}`;
};

